<template>
  <AuthLayout :mode="mode">
    <Section
      heading="IBM Information for ASCDI Members only"
      description="One of the jobs of the ASCDI is to communicate with IBM and IBM Global Asset Recovery Services (IBM GARS) on behalf or our Members in order to keep our members informed about IBM's Practices and Polices. We thank IBM for working with us to include in Members Only section of this Web site the information below."
      :mode="mode"
    />
    <AppCard :mode="mode">
      <template #body>
        <div class="flex flex-col gap-6 sm:gap-4">
          <div>
            <h2
              class="text-[22px] font-semibold leading-none text-primary-100 sm:text-[18px] sm:leading-[1.4]"
            >
              <a
                href="http://www.ascdi.com/wp-content/uploads/2014/12/ASCDI_Doing-Biz-with-GARS_March_2019.pdf"
                target="_blank"
              >
                IBM GARS US WEBINAR- MARCH 2019
              </a>
            </h2>
          </div>
          <div
            class="border-b pb-6 sm:pb-5"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <div class="grid gap-2">
              <h3 class="text-[18px] font-semibold">
                IBM GARS USA CONTACT INFORMATION
              </h3>
              <div class="flex flex-col gap-3">
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p class="text-[14px] font-semibold">Storage</p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Irene Caldwell - NA Storage Business Unit Executive
                    <br />
                    203-722-0662 <br />
                    <a
                      href="mailto:irene.caldwell@ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      irene.caldwell@ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Maryann Collopy - Storage Product Manager <br />
                    914-325-6196 <br />
                    <a
                      href="mailto:mcollopy@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      mcollopy@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Rebecca Kelesidis - Storage Inventory Sales <br />
                    203-829-7990 <br />
                    <a
                      href="mailto:athens@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      athens@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Tim Gerlander - Storage Inventory Sales <br />
                    321-217-3683 <br />
                    <a
                      href="mailto:tgerlan@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      tgerlan@us.ibm.com
                    </a>
                  </p>
                </div>
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p class="text-[14px] font-semibold">Servers</p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Marc Renzella - NA Power & Mainframe Business Unit Executive
                    <br />
                    905-316-1902 <br />
                    <a
                      href="mailto:mrenzell@ca.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      mrenzell@ca.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Rob Hinkle - Power Product Manager <br />
                    203-240-2158 <br />
                    <a
                      href="mailto:hinkle@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      hinkle@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Greg Smayda - Mainframe Product Manager
                    <br />
                    914-765-5572 <br />
                    <a
                      href="mailto:smayda@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      smayda@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Vince Autera - Power Inventory Sales <br />
                    347-920-6040 <br />
                    <a
                      href="mailto:vautera@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      vautera@us.ibm.com
                    </a>
                  </p>
                </div>
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p class="text-[14px] font-semibold">PCs, Intel Servers</p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Bill Flynn - NA Mobility and ARS Business Unit Executive
                    <br />
                    914-765-5619 <br />
                    <a
                      href="mailto:wjflynn@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      wjflynn@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Gary Lesson - Remarketing Manager <br />
                    914-765-5060 <br />
                    <a
                      href="mailto:garyl@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      garyl@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Truman Ta - Remarketing Manager
                    <br />
                    415-320-2358 <br />
                    <a
                      href="mailto:tcta@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      tcta@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Chuck Osbourne - Intel Server Sales <br />
                    720-396-3089 <br />
                    <a
                      href="mailto:cbo@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      cbo@us.ibm.com
                    </a>
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Leanne Summers - PC Sales <br />
                    914-589-3415 <br />
                    <a
                      href="mailto:cullam@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      cullam@us.ibm.com
                    </a>
                  </p>
                </div>
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p class="text-[14px] font-semibold">PTX and Quick Ship</p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Anthony Brunetto <br />
                    914-329-3832 <br />
                    <a
                      href="mailto:anthony.brunetto@ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      anthony.brunetto@ibm.com
                    </a>
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <p class="text-[14px] font-semibold">
                    GARS PrivateTrading Exchange
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    ID Registration
                    <br />
                    888-897-9129 <br />
                    <a
                      href="mailto:ptxreg@us.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      ptxreg@us.ibm.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="border-b pb-6 sm:pb-5"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <div class="grid gap-2">
              <h3 class="text-[18px] font-semibold">
                IBM GARS EUROPEAN CONTACT INFORMATION
              </h3>
              <div class="flex flex-col gap-3">
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p
                    class="text-[14px] font-semibold"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Peter Viuf
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    European Power Systems Sales Leader
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Power Systems AIX, Linux and IBM i
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    GARS European Centre Of Excellence
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Phone: +45 2880 4577
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Email:
                    <a
                      href="mailto:viuf@dk.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      viuf@dk.ibm.com
                    </a>
                  </p>
                </div>
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p
                    class="text-[14px] font-semibold"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Ryan Scot Myall
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    IBM GLOBAL FINANCE (IGF)
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    GARS, MANAGER (SALES, EXTERNAL)
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    SYSTEM Z
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    EUROPE IOT
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    FRANCE
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Phone: +33 6 89 84 87 89
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Email:
                    <a
                      href="mailto:Ryan.scot.myall@fr.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      Ryan.scot.myall@fr.ibm.com
                    </a>
                  </p>
                </div>
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p
                    class="text-[14px] font-semibold"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Alexander Welk
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    European Broker Sales System Storage & PC
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Global Asset Recovery Services
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    IBM Global Financing - European Center of Excellence
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Phone: +49-(0)172-740-3839
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Fax: +49-07034-15-3050
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Mobile: +49-(0) 172-740-3839
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Email:
                    <a
                      href="mailto:alexander.welk@de.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      alexander.welk@de.ibm.com
                    </a>
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <p
                    class="text-[14px] font-semibold"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Greg Knox
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Product Manager IBM System Storage & PC Products
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    European Broker Sales Leader
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    GARS European Centre Of Excellence
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    IBM Deutschland GbmH
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    BM Alle 1, 71139 Ehningen, Germany
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Mobile: +49-172-6382382
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    AOL IM: gregknox_IBM
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Email:
                    <a
                      href="mailto:gknox@de.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      gknox@de.ibm.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="grid gap-2">
              <h3 class="text-[18px] font-semibold">
                IBM INDIA and ASIA PACIFIC CONTACT INFORMATION
              </h3>
              <div class="flex flex-col gap-3">
                <div
                  class="flex flex-col gap-2 border-b pb-3"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <p
                    class="text-[14px] font-semibold"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Michael Nguyen
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Product Manager for Asia Pacific
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Email:
                    <a
                      href="mailto:minguyen@au1.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      minguyen@au1.ibm.com
                    </a>
                  </p>
                </div>
                <div class="flex flex-col gap-2">
                  <p
                    class="text-[14px] font-semibold"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Jo Yo / 尤美蘭
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    GARS Specialist
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    IBM Global Financing -Taiwan & HongKong & PRC assinged
                    account
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Mobile no: +886 963 630 559
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Tel no: +886 2 8723 9857
                  </p>
                  <p
                    class="text-[14px] font-medium"
                    :class="[
                      mode === 'dark' ? 'text-dark-text' : 'text-black-80',
                    ]"
                  >
                    Email:
                    <a
                      href="mailto:joyotw@tw.ibm.com"
                      class="hover:text-primary-100 hover:underline"
                    >
                      joyotw@tw.ibm.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </AppCard>
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import AppCard from "@C/Common/AppCard.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "IBMInformation",
  components: {
    AuthLayout,
    Section,
    AppCard,
  },
  props: {
    mode: String,
  },
};
</script>
